import React, { createContext, useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { auth } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";

// Import pages
import Home from "./pages/Home";
import Notes from "./pages/Notes";
import PYQs from "./pages/PYQs";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NotePreview from "./pages/NotePreview";
import AuthPage from "./pages/AuthPage";
import SavedNotes from "./pages/SavedNotes";
import AllNotes from "./pages/AllNotes";
import SeoPreview from "./pages/SeoPreview";
import AIBEPreparation from "./pages/AIBEPreparation";

// Import Protected Route
import ProtectedRoute from "./components/ProtectedRoute";

// Create Auth context
export const AuthContext = createContext();

// Analytics component to track page views
const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-6GN0JRKBY0", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser, loading }}>
      <Router>
        <Analytics />

        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/auth" element={<AuthPage />} />

          <Route
            path="/notes/:degree?/:course?/:semester?/:subject?"
            element={<Notes />}
          />

          <Route
            path="/pyqs/:degree?/:course?/:semester?/:subject?"
            element={<PYQs />}
          />
    
    
          <Route
            path="/preview/:course/:sem/:filename"
            element={
              <ProtectedRoute>
                <NotePreview />
              </ProtectedRoute>
            }
          />
          <Route path="/savednotes" element={<SavedNotes />} />
          <Route path="/all-notes" element={<AllNotes />} />
          <Route path="/aibe-preparation/:subpage?" element={<AIBEPreparation />} />
          
          {/* Public SEO Preview Route */}
          <Route 
            path="/preview/:degree/:course/:semester/:subject" 
            element={<SeoPreview />} 
          />
        </Routes>
      </Router>
    </AuthContext.Provider>
  );
}

export default App;
